module.exports = __webpack_public_path__ + "static/media/video_1.043c447.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/video_1.mp4
// module id = 6HVn
// module chunks = 0